import { Users, PenLine, ShieldCheck, Wallet } from "lucide-react";
import { Reveal, MaskLines } from "./motion";
import { GALLERIES } from "../../lib/assets";
import { GlassCard, DeviceMock } from "./Glass";

const rows = [
  { icon: Users, label: "Ahorra con tu pareja, amigos o socios" },
  { icon: PenLine, label: "Cada movimiento requiere m de n firmas" },
  { icon: ShieldCheck, label: "Cada miembro con KYC aprobado" },
  { icon: Wallet, label: "Nadie mueve dinero sin permiso" },
];

export const Multifirma = () => {
  return (
    <section
      id="multifirma"
      data-testid="multifirma-section"
      className="relative flex min-h-screen items-center overflow-hidden bg-canvas px-6 pb-24 pt-28 text-ink md:px-12"
    >
      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-16 lg:grid-cols-2">
        <div>
          <span className="font-accent text-xs uppercase tracking-[0.2em] text-ink-soft">
            Cuentas mancomunadas
          </span>
          <h2 className="mt-4 font-display text-4xl font-light leading-[0.95] tracking-tight text-ink md:text-6xl">
            <MaskLines lines={["Ahorra en compañía.", "Cada movimiento,", "firmado."]} />
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-md font-body text-base leading-relaxed text-ink-soft md:text-lg">
              Crea wallets multifirma para ahorrar con tu pareja, amigos o
              socios. Cada movimiento requiere la firma de m de n participantes:
              nadie mueve el dinero sin tu permiso.
            </p>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <span className="rounded-full bg-ink/5 px-4 py-1.5 font-accent text-sm text-ink">
                Umbral 2 / 2 firmas
              </span>
              <span className="rounded-full bg-forest/10 px-4 py-1.5 font-accent text-sm text-forest">
                Wallet activa
              </span>
            </div>
          </Reveal>

          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {rows.map((r, i) => (
              <GlassCard
                key={r.label}
                delay={0.08 * i}
                className="flex items-center gap-3 p-5"
              >
                <r.icon className="h-5 w-5 shrink-0 text-gold" strokeWidth={1.5} />
                <span className="font-accent text-sm text-ink">{r.label}</span>
              </GlassCard>
            ))}
          </div>
        </div>

        <GlassCard testId="multifirma-device" delay={0.15} className="p-8 md:p-10">
          <DeviceMock
            src={GALLERIES.multifirma[0].src}
            alt={GALLERIES.multifirma[0].alt}
            className="min-h-[440px]"
            imgClassName="max-h-[540px]"
          />
        </GlassCard>
      </div>
    </section>
  );
};
